import { apiAddress } from "../../config/server";
import { ITimeSheetEntry } from "../../types/timesheet/Timesheet";
import { ApiBase, GenericTransport } from "./baseApi";

export interface IPayEventResponse {
    _id: string
    description: string
    createdAt: string
    paidAt: string
    total: number
    count: number
    person: string
}

export default class TimesheetApi extends ApiBase {
    static URL = apiAddress + '/api/timesheet/'

    static getTimesheetEntries(person?: string): Promise<ITimeSheetEntry[]> {
        const url = this.URL + "entry/person/" + (person || '');
        return TimesheetApi.get<ITimeSheetEntry[]>(url).then(
            (resp) => resp.data.data || [],
        );
    }

    static createTimesheetEntry(entry: Partial<ITimeSheetEntry>): Promise<ITimeSheetEntry> {
        return TimesheetApi.put<ITimeSheetEntry>(this.URL + "entry/", entry).then(
            (resp) => resp.data.data,
        )
    }

    static getUnpaidTimesheetEntriesForAssociation(association: string): Promise<GenericTransport<ITimeSheetEntry[]>> {
        // entry/association/:associationId/unpaid
        const url = `${this.URL}entry/association/${association}/unpaid`;
        return TimesheetApi.get<ITimeSheetEntry[]>(url).then(
            (resp) => resp.data);
    }

    static markAsPaid(associationId: string, entryIds: string[]) {
        const url = `${this.URL}payevent/pay/${associationId}`
        const body = {
            timesheetIds: entryIds,
        }
        return TimesheetApi.post(url, body)
            .then((resp) => true)
    }

    static rejectEntries(associationId: string, entryIds: string[], comment: string) {
        const url = `${this.URL}payevent/reject/${associationId}`
        const body = {
            timesheetIds: entryIds,
            reason: comment,
        }
        return TimesheetApi.post(url, body)
            .then((resp) => true)
    }

    static getEventsByAssociationId(associationId: string): Promise<IPayEventResponse[]> {
        const url = `${this.URL}payevent/association/${associationId}`
        return TimesheetApi.get<IPayEventResponse[]>(url)
            .then((resp) => resp.data.data)
    }

    static getPayEventPdfLink(eventId: string): string {
        return `${this.URL}payevent/${eventId}/pdf`
    }
}
